import Table, { TableProps } from 'components/table';
import React, { useEffect, useMemo, useState } from 'react';
import { useAppDispatch, useTypedSelector } from 'store/index';
import { fetchApplicationAccounts } from 'store/application';
import { post } from 'store/request';
import { hideDialog, showDialog } from 'components/dialog';
import { Icon, message } from '@tencent/spaui';
import { report } from 'store/report';
import { setAuthStatus } from 'store/user';
import Bottom from 'components/auth/bottom';

const authHeaders: TableProps['headers'] = [
  {
    label: '账户ID',
    name: 'account_id',
    width: 328,
    tooltip: '您可开通的服务商ID或直客ID',
  },
  {
    label: '账户名称',
    name: 'account_name',
    width: 328,
  },
];

const AuthDialog: React.FC<{ id: string }> = ({ id }) => {
  const [selected, setSelected] = useState<string[]>([]);
  const [loading, setLoading] = useState<boolean>();
  const dispatch = useAppDispatch();
  const {
    user: { user },
    application: { appAccountsMap, appAccountsLoading },
  } = useTypedSelector((state) => state);

  const data = useMemo(() => {
    return appAccountsMap?.[id]?.filter(({ role, auto_authed }) => role === 10 || role === 100 || auto_authed);
  }, [appAccountsMap, id]);

  useEffect(() => {
    dispatch(fetchApplicationAccounts(id));
    /* eslint-disable-next-line react-hooks/exhaustive-deps*/
  }, [id]);

  const handleAuth = () => {
    if (loading) {
      return;
    }

    const list = selected.filter((value) => {
      const account = appAccountsMap[id].find(({ account_id }) => account_id === value);
      return !account.status;
    });

    if (list.length) {
      setLoading(true);
      const params = {
        client_id: id,
        account_ids: list,
        logins: {
          login_type: user.login_type,
          login_name_type: user.login_name_type,
          login_name: user.qq_number || user.wx_id,
        },
      };
      post('/authorization', params)
        .then((res) => {
          showDialog({
            className: 'auth-success',
            content: (
              <>
                <Icon name="check-filled" />
                <div className="text-bold">已成功开通应用！</div>
                <span className="rect-button light" role="button" onClick={() => hideDialog()}>
                  完成
                </span>
              </>
            ),
          });
          report({ event: 'request-auth', client_id: id, payload: JSON.stringify(params) });
          const data = {
            id,
            authorize_status: res?.authorize_status,
            super_admin_status: res?.super_admin_status,
            authorize_account_count: res.authorize_account_count,
          };
          dispatch(setAuthStatus(data));
        })
        .catch((err) => {
          message.error(err);
        })
        .finally(() => setLoading(false));
    }
  };

  return (
    <>
      <Table
        topContent={<div className="text-bold">选择开通账户</div>}
        tips={
          <div style={{ textAlign: 'left', padding: '0 0 12px 0', color: '#888' }}>
            如账号ID未显示，可通过点击【管理中心-应用查看】检查工具开通状态，根据页面提示进行工具开通。
          </div>
        }
        headers={authHeaders}
        selectableCol="account_id"
        selectAll
        selected={selected}
        searchableCols={['account_id', 'account_name']}
        data={data}
        loading={appAccountsLoading}
        canOptional={({ status }: { status: 0 | 1 }) => !status}
        onSelected={(value) => setSelected(value)}
      />
      <Bottom
        id="auth"
        clientId={id}
        licenses={[{ url: '/license01.pdf', track: 'link-license', label: '腾讯广告营销服务市场用户服务协议' }]}
        loading={loading}
        btnLabel="同意开通"
        onConfirm={handleAuth}
      />
    </>
  );
};

export default AuthDialog;
